<template>
  <div class="hello page_repeat">
    <remindListTop @event3="change3($event)" @transformVal="getVal" @fatherMethod="getremindlist"></remindListTop>
    <!-- <repeat v-if="isHandled==0"></repeat>
      <repeatProcessed v-if="isHandled==1"></repeatProcessed> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>通知</el-breadcrumb-item>
          <el-breadcrumb-item>待办事项</el-breadcrumb-item>
          <el-breadcrumb-item>重复入职提醒</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span v-show="isHandled =='0'">待处理</span>
            <span v-show="isHandled =='1'">已处理</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="idCardTable">
        <!-- @cell-click="handdle" -->
        <el-table :data="tableData" :max-height="tableHeight-180" style="width: 99%" stripe v-loading='listLoading'>
          <!-- <el-table-column align="center" type="selection" width="50px"></el-table-column> -->
          <el-table-column align="center" label="序号" prop="num" width="50"></el-table-column>
          <el-table-column align="center" label="项目名称" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.StrObjName}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="档案号" prop="StrFileNo" min-width="10%"></el-table-column> -->
          <el-table-column align="center" label="姓名" min-width="70px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.StrEmpName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="身份证号码" min-width="160px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.StrIdCard}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="重复入职次数" min-width="70px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span style="cursor:pointer;color: #F78500;" @click="seeDetail(row)">{{row.doublecount}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" label="操作" min-width="80px">
            <template slot-scope="{row}">
              <el-button type="success" size="small" plain @click="seeDetail(row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="totalcount>0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage3" :page-size="pagecount" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="this.totalcount"></el-pagination>
        </div>
        <el-dialog title="确认处理" :visible.sync="dialogVisible" width="30%">
          <span>若您已在线下完成处理，无需再进行其他线上操作，请点击确认</span>
          <span slot="footer" class="dialog-footer">
            <button class="clear" @click="dialogVisible = false">取消</button>
            <button class="search" @click="changeSolve" style="margin-left:10px;font-weight:600">确定</button>
          </span>
        </el-dialog>
        <el-dialog title="撤销处理" :visible.sync="dialogVisible3" width="30%">
          <span>点击“撤销处理”后，本条待办事项将重新在“待办事项”列表中</span>
          <span slot="footer" class="dialog-footer">
            <button class="clear" @click="dialogVisible3 = false">取消</button>
            <button class="search" @click="revokeSubmit" style="margin-left:10px;font-weight:600">确定</button>
          </span>
        </el-dialog>
        <el-drawer :visible.sync="drawer" :with-header="false" :modal="false" size="72%">
          <div class="repeatTitleAndButton">
            <div class="monthlyTitle">重复入职详情 | {{dtlUserName}}</div>
            <div>
              <button class="exportButton" style="margin-right:10px" v-if="isHandled =='0'" @click="changeSelectState">确认处理选中人员</button>
              <button class="exportButton" style="margin-right:10px" v-if="isHandled =='1'" @click="changeSelectState">确认撤销选中人员</button>
              <button class="clear" @click="close" style="margin-right:5px">关闭</button>
            </div>
          </div>
          <div>
            <div class="monthlyChannelTable">
              <el-table :data="tableData3" style="width: 99%" v-loading="drawerLoading" stripe @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="50px"></el-table-column>
                <el-table-column align="center" label="序号" width="40">
                  <template slot-scope="{$index}">
                    <span>{{Number($index) +1}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="服务中心">
                  <template slot-scope="{row}">
                    <span>{{row.StrSrvCent}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="项目名称" min-width="130px">
                  <template slot-scope="{row}">
                    <span>{{row.StrObjName}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="档案号" min-width="100px">
                  <template slot-scope="{row}">
                    <span>{{row.StrFileNo}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="姓名">
                  <template slot-scope="{row}">
                    <span>{{row.StrEmpName}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="在/离职状态">
                  <template slot-scope="{row}">
                    <span>{{row.StrWorkState}}</span>
                  </template></el-table-column>
                <el-table-column align="center" label="合同（协议）类型" min-width="130px">
                  <template slot-scope="{row}">
                    <span>{{row.StrContractType}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="用工之日" min-width="90px">
                  <template slot-scope="{row}">
                    <span>{{!isNull(row.DtEntryBdate)?row.DtEntryBdate.substring(0,10):''}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="负责客服">
                  <template slot-scope="{row}">
                    <span>{{row.StrUserName}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="80px">
                  <template slot-scope="{row,$index}">
                    <button class="changeState" @click="itemHandle(row,$index)" v-if="isHandled =='0'">确认处理</button>
                    <button class="changeState" @click="revokeHandle(row,$index)" v-if="isHandled == '1'">撤销处理</button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-drawer>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "./../../common";
  import remindListTop from "./components/remindListTop";
  // import repeat from "./repeat";
  // import repeatProcessed from "./repeatProcessed";
  export default {
    components: {
      remindListTop
    },
    data() {
      return {
        tableHeight: 0,
        listLoading: false,
        drawerLoading: false,
        isHandled: 0,
        currpage: 1,
        status: 0,
        totalcount: 0,
        drawer: false,
        dialogVisible: false,
        dialogVisible3: false,
        currentPage3: 1,
        remindQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 10,
          currpage: 1,
          content: 'double',
          strstatus: "0",
          strempname: ""
        },
        pagecount: 10,
        isHandled: 0,
        tableData: [],
        //确认处理参数-档案号
        strfileno: '',
        tableData3: [],
        //详情人员名称
        dtlUserName: '',
        multipleSelection: [],
        //第几行数据
        tableIndex: 0,
        //选中的数据
        rowSelection: [],
        //是否是多选处理
        isMultiple: false,
        info: {}
      }
    },
    mounted() {
      this.calHeight();
      this.getremindlist();
    },
    methods: {
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      handleClick(row) {
        console.log(row);
      },
      //分页转跳
      handleCurrentChange(val) {
        this.currpage = `${val}`;
        this.remindQuery.currpage = `${val}`;
        this.getremindlist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.remindQuery.pagecount = `${val}`;
        this.pagecount = parseInt(val);
        this.getremindlist();
      },
      change3(data) {
        this.isHandled = data;
        this.remindQuery.strstatus = data
        this.remindQuery.currpage = 1
        this.remindQuery.content = 'double'
      },
      getVal(data) {
        // console.log('名称',data)
        this.remindQuery.strempname = data
      },
      //更改选中
      changeSelectState() {
        this.isMultiple = true
        if (this.isHandled == '0') {
          this.dialogVisible = true
        } else {
          this.dialogVisible3 = true
        }
        this.strfileno = this.multipleSelection.toString()
      },
      //选中值
      handleSelectionChange(val) {
        console.log('选中值', val)
        this.rowSelection = val
        this.multipleSelection = []
        if (val && Array.isArray(val)) {
          for (let index = 0; index < val.length; index++) {
            const elementVal = val[index];
            this.multipleSelection.push(
              elementVal.StrFileNo)
          }
        }
        // console.log('选中值',this.multipleSelection)
      },
      //处理
      itemHandle(row, index) {
        this.info = row;
        console.log('ssd', index)
        this.tableIndex = index
        this.dialogVisible = true;
        this.isMultiple = false
        this.strfileno = row.StrFileNo
      },
      //确认处理
      changeSolve() {
        let d = {
          status: 1, //1 处理，0 退回
          content: 'double',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "处理成功！",
              type: "success"
            });
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible = false;
        });
      },
      //撤销
      revokeHandle(row, index) {
        this.info = row;
        this.tableIndex = index
        this.dialogVisible3 = true;
        this.isMultiple = false
        this.strfileno = row.StrFileNo
      },
      //确认撤销处理
      revokeSubmit() {
        let d = {
          status: 0, //1 处理，0 退回
          content: 'double',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "撤销成功！",
              type: "success"
            });
            this.dialogVisible3 = false;
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible3 = false;
        });
      },
      getVal(data) {
        // console.log('名称',data)
        this.remindQuery.strempname = data
      },
      handdle(row, event, column, cell) {
        if (event.label == "重复入职次数") {
          this.drawer = true;
        }
      },
      seeDetail(item) {
        this.drawerLoading = true
        this.tableData3 = item.data
        this.dtlUserName = item.StrEmpName
        this.drawer = true;
        this.drawerLoading = false
      },
      close() {
        this.drawer = false;
      },
      //获取待办事项列表
      getremindlist() {
        console.log('待办事项列表', this.remindQuery)
        this.tableData = []
        this.listLoading = true
        xz.getremindlist(this.remindQuery).then(res => {
          console.log('待办事项列表', res)
          if (res) {
            if (res.dateall && res.dateall.length > 0) {
              let i = 1 + (this.currpage - 1) * 10;
              res.dateall.forEach(l => {
                l['num'] = i++;
              })
              this.tableData = res.dateall;
              this.totalcount = parseInt(res.count);
            } else {
              this.tableData = []
              this.totalcount = 0
            }
          }
          this.listLoading = false
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .page_repeat .textBox {
    width: 220px;
  }
</style>